import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Label } from "@/components/ui/label";
import { useCallback, useMemo } from "react";
import { ScannerImage, Scanners, ScannerValue } from "..";
import { Card, CardContent, CardFooter, CardTitle } from "@/components/ui/card";
import { useRouter } from "next/router";

interface FooterProps {
  userLoggedIn: boolean;
  scanner: ScannerValue;
}
const Footer: React.FC<FooterProps> = ({ scanner }) => {
  const router = useRouter();
  const scanners = useMemo(
    () => Scanners.filter((i) => i.value !== scanner),
    [scanner]
  );
  const onScannerClick = useCallback(
    (scanner: ScannerValue) => {
      if (scanner) {
        const { slug, ...query } = router.query;
        router.push({
          query,
          pathname: "/scanner/" + scanner,
        });
      }
    },
    [router]
  );
  return (
    <div className="flex gap-4 flex-col">
      <Label className="text-2xl">Explore more scanners</Label>
      <div className="px-14">
        <Carousel className="w-full">
          <CarouselContent className="w-full">
            {scanners.map((item, index) => {
              const ScannerSVG = ScannerImage[item.value];
              return (
                <CarouselItem className="md:basis-1/2 lg:basis-1/3" key={index}>
                  <div className="p-1">
                    <Card
                      onClick={() => onScannerClick(item.value)}
                      className="border-none bg-transparent w-full cursor-pointer"
                    >
                      <CardContent className="w-full flex items-center justify-center p-6">
                        <ScannerSVG
                          width="100%"
                          height="100%"
                          className="border border-blue-700"
                        />
                      </CardContent>
                      <CardFooter className="justify-center">
                        <CardTitle className="text-md font-bold">
                          {item.label}
                        </CardTitle>
                      </CardFooter>
                    </Card>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>
    </div>
  );
};
export default Footer;
